import * as z from "zod/v4";

export const updateYotpoIntegration = {
  name: "updateYotpoIntegration" as const,
  input: z.object({ webhooksEnabled: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
